<template>
  <div>
    <div id="ResultsStage">
      <template v-if="ResultReady">
        <template v-if="EligibilityResult">
          <template v-if="AdultEligible">
            <el-card class="box-card SEEligible">
              <i class="material-icons">check_circle</i>
              <h2>You May Be Eligible To Seal/Expunge</h2>
              <p>It appears that you may be able to seal or clear your record. Depending on where you live, there may be assistance available to help you.
                <template v-if="ExceptionApplies">NOTE: Your ability to clear your record is based on a court deciding that a special exception applies.</template>
              </p>
              <el-checkbox v-model="RequestsExpungementHelp">I want help clearing my record.</el-checkbox>
            </el-card>
          </template>

          <template v-else-if="JuvenileEarlyEligible">
            <el-card class="box-card SEEligible">
              <i class="material-icons">check_circle</i>
              <h2>You May Be Eligible To Seal/Expunge Early</h2>
              <p>In Florida, juvenile records are automatically expunged when the person turns 21.  You may be able to apply to expunge early.
                <template v-if="ExceptionApplies"> NOTE: Your eligibility is dependent on a court determining that a special exception applies.</template>
              </p>
              <el-checkbox v-model="RequestsExpungementHelp">I want help clearing my record.</el-checkbox>
            </el-card>
          </template>

          <template v-else>
            <el-card class="box-card SEEligible">
              <i class="material-icons">check_circle</i>
              <h2>Your Record Should Have Been Expunged</h2>
              <p>In Florida, juvenile records are automatically expunged when the person turns 21.  Please check with the Clerk of Court to see if they did.
              </p>
            </el-card>
          </template>
        </template>

        <template v-else>
          <el-card class="box-card SEIneligible">
            <i class="material-icons">error</i>
            <h2>You May NOT Be Eligible to Seal/Expunge</h2>
            <p>{{ EligibilityError }}Consult a local attorney for a more detailed examination of your options.</p>
          </el-card>
        </template>

        <template v-if="ConsumerIssueResult">
          <el-card class="box-card ConsumerOpportunity">
            <i class="material-icons">search</i>
            <h2>You May Have A Consumer Case</h2>
            <p>Based on the answers you provided, you may have an issue with your credit report. Would you like to know
              more about your rights?</p>
            <el-checkbox v-model="RequestsConsumerHelp">I want help reviewing my credit report.</el-checkbox>
          </el-card>
        </template>
      </template>
      <template v-else>
        <img src="img/notice_icons/pointing-up-emoji.png" align="center" width="100px" height="100px" alt="An emoji stylized picture of a hand with the index finger pointing up.">
        <div id="StatusNotice">Please answer the questions above and click "Continue" after each section.</div>
      </template>
    </div>
    <div style="clear: both; line-height: 0px; height: 0px;">&nbsp;</div>
    <div align="center">
      <template v-if="DisplayFindHelpButton">
        <el-button type="primary" @click="findHelp">Find Help</el-button>
      </template>
      <template v-if="ConsumerIssueResult || EligibilityResult">
        <el-button type="primary" @click="selfHelp">Self-Help</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from '../../EligibilityEventBus.js'

import { Card, Checkbox, Button } from 'element-ui' // eslint-disable-line no-unused-vars

export default {
  data: function () {
    return {
      ResultReady: false,
      EligibilityResult: false,
      ExceptionApplies: false,
      AdultEligible: false,
      JuvenileEarlyEligible: false,
      EligibilityError: '',
      EligibilityExceptionNotes: '',
      completedDiversion: null,
      ConsumerIssueResult: false,
      RequestsExpungementHelp: true,
      RequestsConsumerHelp: true
    }
  },

  props: {
    profileData: {
      type: Object
    },
    chargeData: {
      type: Object
    }
  },

  components: {
    'el-card': Card,
    'el-checkbox': Checkbox,
    'el-button': Button
  },

  computed: {
    DisplayFindHelpButton: function () {
      if ((this.ConsumerIssueResult || this.AdultEligible || this.JuvenileEarlyEligible) && (this.RequestsExpungementHelp || this.RequestsConsumerHelp)) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    calculateResults: function () {
      if (this.profileData.complete && this.chargeData.complete) {
        this.ResultReady = true

        // Screen for consumer issue.
        this.detectConsumerIssue()

        // Screen for Eligibility.
        if (this.isGenerallyEligible()) {
          this.EligibilityResult = true
          console.log('Visitor is generally eligible.') // eslint-disable-line no-console

          if (this.isJuvenileCase()) {
            this.AdultEligible = false
            console.log('Visitor has a juvenile case.') // eslint-disable-line no-console

            if (this.isEarlyEligible()) {
              this.JuvenileEarlyEligible = true
              console.log('Visitor is early expungement eligible.') // eslint-disable-line no-console
            } else {
              this.JuvenileEarlyEligible = false
              console.log('Visitor is NOT early expungement eligible.') // eslint-disable-line no-console
            }
          } else {
            this.AdultEligible = true
            console.log('Visitor has an adult case.') // eslint-disable-line no-console
          }
        } else {
          this.EligibilityResult = false
          console.log('Visitor is NOT generally eligible.') // eslint-disable-line no-console
        }

        if (this.profileData.ES0Q9 === 'Yes') {
          this.completedDiversion = true
        } else {
          this.completedDiversion = false
        }

        EventBus.$emit('completedEligibility', { isEligible: this.EligibilityResult, isJuvenile: !this.AdultEligible, isEarlyEligible: this.JuvenileEarlyEligible, completedDiversion: this.completedDiversion, notes: this.EligibilityExceptionNotes })
      } else {
        console.log(`Profile and/or Charge data missing.`)
      }
    },

    detectConsumerIssue: function () {
      var ConsumerIssueResult
      var ConsumerIssueNotes = ''

      // Screen for consumer issues.
      if (this.profileData.ES0Q3 === 'Yes' || this.profileData.ES0Q4 === 'Yes' || this.profileData.ES0Q5 === 'Yes' || this.profileData.ES0Q6 === 'Yes') {
        ConsumerIssueResult = true

        if (this.profileData.ES0Q3 === 'Yes') { ConsumerIssueNotes += 'Denied Job, ' }
        if (this.profileData.ES0Q4 === 'Yes') { ConsumerIssueNotes += 'Denied Housing, ' }
        if (this.profileData.ES0Q5 === 'Yes') { ConsumerIssueNotes += 'Victim of ID Theft, ' }
        if (this.profileData.ES0Q6 === 'Yes') { ConsumerIssueNotes += 'Denied Credit ' }

        console.log('Consumer issue detected.') // eslint-disable-line no-console
      } else {
        ConsumerIssueResult = false
        console.log('No consumer issue detected.') // eslint-disable-line no-console
      }

      this.ConsumerIssueResult = ConsumerIssueResult

      EventBus.$emit('completedConsumerEligibility', { result: ConsumerIssueResult, notes: ConsumerIssueNotes })
    },

    isGenerallyEligible: function () {
      if (this.profileData.ES0Q1 === 'No') {
        this.EligibilityError = this.EligibilityError.concat('You need to have been arrested or charged. ')
        return false
      }

      if (this.profileData.ES0Q2 === 'No') {
        this.EligibilityError = this.EligibilityError.concat('You need to have paid all court costs and fees associated with your criminal case or arrest. ')
        return false
      }

      if (this.profileData.ES0Q10 === 'Yes') {
        this.EligibilityError = this.EligibilityError.concat('You cannot have multiple convictions if you want to clear your record. ')
        return false
      }

      if (this.chargeData.ES1Q1 || this.chargeData.ES1Q2 || this.chargeData.ES1Q3 || this.chargeData.ES1Q4 || this.chargeData.ES1Q5 || this.chargeData.ES1Q6 || this.chargeData.ES1Q7 || this.chargeData.ES1Q8 || this.chargeData.ES1Q9 || this.chargeData.ES1Q10) {
        var isEligible = false

        if (this.chargeData.ES1Q11) {
          isEligible = true
          this.ExceptionApplies = true
          this.EligibilityExceptionNotes += 'Possible self-defense exception, '
        }

        if (this.chargeData.ES1Q12) {
          isEligible = true
          this.ExceptionApplies = true
          this.EligibilityExceptionNotes += 'Possible human-trafficking exception, '
        }

        if (!isEligible) {
          this.EligibilityError = this.EligibilityError.concat('You cannot have commited one of the special classes of offenses. ')
        }

        return isEligible
      } else {
        return true
      }
    },

    isJuvenileCase: function () {
      if (this.profileData.ES0Q7 === 'Yes') {
        return true
      } else {
        return false
      }
    },

    isEarlyEligible: function () {
      if (parseInt(this.profileData.ES0Q8) < 21) {
        return true
      } else {
        return false
      }
    },

    findHelp: function () {
      EventBus.$emit('requestHelp', { isRequestingExpungementHelp: this.RequestsExpungementHelp, isRequestingConsumerHelp: this.RequestsConsumerHelp })
    },

    selfHelp: function () {
      EventBus.$emit('visitSelfHelp')
    }
  },

  created: function () {
    EventBus.$on('ProfileComplete', this.calculateResults)
    EventBus.$on('ChargesComplete', this.calculateResults)
  },

  beforeMount: function () {
    // Check the status of the result here for routed version.
    this.calculateResults()
  }
}
</script>

<style scoped>
.el-main img {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.el-card {
  max-width: 384px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 340px;
  text-align: left;
}

.el-card h2 {
  text-align: center;
}

.el-card p {
  text-align: left;
}

#ResultsStage .el-button {
  margin-top: 40px;
  margin-bottom: 20px;
}

#ResultsStage {
  min-height: 300px;
  display: inline-block;
  text-align: center;
}

#StatusNotice {
  margin-top: 40px;
  text-align: center;
  font-weight: bold;
}

.SEEligible {
  background-color: #A9FFD1;
}

.SEIneligible {
  background-color: #FFA49E;
}

.ConsumerOpportunity {
  background-color: #c0daf9;
}
</style>
